import React, { useState } from "react";

export const AGENTS = {
  nexus: { name: "Nexus", role: "Floor Chief", color: "#00F0FF", ini: "NX" },
  scott: { name: "Mr Scott", role: "Scout", color: "#38BDF8", ini: "SC" },
  minyo: { name: "Mr Minyo", role: "Small-Cap Scout", color: "#F472B6", ini: "MI" },
  jimmy: { name: "Mr Jimmy", role: "News & catalyst", color: "#F59E0B", ini: "JM" },
  funda: { name: "Mr Funda", role: "Fundamentals", color: "#A3E635", ini: "FU" },
  prakash: { name: "Mr Prakash", role: "Technician", color: "#818CF8", ini: "PK" },
  crams: { name: "Mr Crams", role: "Validator", color: "#2DD4BF", ini: "CR" },
  london: { name: "London", role: "Bull", color: "#10B981", ini: "LD" },
  tariq: { name: "Tariq", role: "Bear", color: "#F43F5E", ini: "TQ" },
  jimmycool: { name: "Jimmy Cool", role: "Risk", color: "#E879F9", ini: "JC" },
  genie: { name: "Mr Genie", role: "Confirmer", color: "#FACC15", ini: "GN" },
  oracle: { name: "Ms Oracle", role: "Kalshi desk", color: "#C084FC", ini: "OR" },
};

export const FloorAvatar = ({ agent, size = 44, glow }) => {
  const a = AGENTS[agent] || { color: "#64748B", ini: "?" };
  const [bad, setBad] = useState(false);
  const st = { width: size, height: size, borderColor: a.color, boxShadow: glow ? `0 0 18px ${a.color}` : "none" };
  return (
    <span className="shrink-0 rounded-full border-2 overflow-hidden flex items-center justify-center transition-shadow duration-500" style={st} data-testid={`floor-avatar-${agent}`}>
      {bad ? <span className="nx-orbitron font-black" style={{ color: a.color, fontSize: size * 0.34, background: `${a.color}22`, width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>{a.ini}</span>
        : <img src={`/avatars/${agent}.png`} alt={a.name} className="w-full h-full object-cover" onError={() => setBad(true)} />}
    </span>
  );
};
